/* eslint-disable max-len */

import React, { DetailedHTMLProps, HTMLAttributes } from 'react'

interface Props extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  svgStyles?: string
}

const LanguageSvg = (props: Props): JSX.Element => {
  const { svgStyles, ...rest } = props

  const img = `
    <svg class=${props.svgStyles ?? ''} version="1.0" xmlns="http://www.w3.org/2000/svg"
    width="100%" height="100%" viewBox="0 0 100.000000 100.000000"
    preserveAspectRatio="xMidYMid meet">
      <g transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)"
      fill="currentColor" stroke="none">
      <path d="M383 946 c-131 -32 -246 -123 -304 -242 -31 -63 -34 -76 -34 -164 1
      -104 15 -150 76 -234 38 -54 35 -80 -23 -167 -32 -48 -39 -65 -31 -78 24 -38
      100 -22 208 43 58 35 75 41 95 34 13 -5 58 -12 100 -15 217 -16 423 122 476
      319 81 305 -231 584 -563 504z m232 -42 c118 -30 216 -108 268 -213 28 -58 32
      -75 32 -151 0 -76 -3 -93 -33 -152 -55 -112 -167 -195 -297 -219 -62 -12 -175
      -6 -219 10 -20 8 -37 3 -102 -34 -75 -43 -141 -71 -149 -63 -2 1 13 29 32 61
      50 79 49 124 0 196 -148 214 -31 494 236 566 70 18 160 18 232 -1z"/>
      <path d="M316 752 c-9 -16 -96 -268 -96 -281 0 -28 33 -8 47 29 16 39 17 40
      63 40 46 0 47 -1 63 -40 9 -23 22 -40 31 -40 23 0 21 11 -32 159 -44 125 -62
      156 -76 133z m33 -123 c16 -46 14 -49 -19 -49 -16 0 -30 4 -30 9 0 18 22 71
      30 71 4 0 13 -14 19 -31z"/>
      <path d="M647 614 c-4 -4 -7 -18 -7 -30 0 -21 -5 -23 -57 -26 -44 -2 -58 -7
      -58 -18 0 -12 18 -16 93 -18 105 -3 108 -7 61 -72 l-31 -43 -32 38 c-20 23
      -37 35 -44 31 -17 -11 -15 -21 13 -54 14 -17 25 -34 25 -39 0 -5 -20 -19 -45
      -31 -44 -21 -61 -52 -29 -52 9 0 38 12 64 26 l48 26 46 -27 c42 -25 66 -26 66
      -5 0 6 -18 21 -39 35 l-40 25 35 57 c19 31 34 62 34 69 0 7 10 14 23 16 12 2
      22 10 22 18 0 11 -14 16 -57 18 -53 3 -57 5 -60 29 -3 27 -18 39 -31 27z"/>
      </g>
    </svg>

  `
  return <div {...rest} dangerouslySetInnerHTML={{ __html: img }} />
}

export default LanguageSvg
